export default function idToName(id) {
  return id.replaceAll('_', ' ')
}
